import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { GAME_TYPES_TYPE } from '../../../../constants/constants';
import { AIDifficultyLevel } from '../../PlayWithAI/useJoinAiGameMutation.gql';

// 1. Define the mutation
const mutation = gql`
  mutation incrementGymAIPracticeGamesWon($input: IncrementGymAIPracticeGamesWonInput!) {
    incrementGymAIPracticeGamesWon(input: $input) {
      _id
      userId
      gameType
      aiDifficultyLevel
      played
      won
    }
  }
`;

// 2. Define TypeScript types for input and return shape
export interface IncrementGymAIPracticeGamesWonInput {
  aiDifficultyLevel: AIDifficultyLevel;
  gameType: GAME_TYPES_TYPE;
  userId: string;
}

export interface GymAIPracticeGame {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  aiDifficultyLevel: AIDifficultyLevel;
  played: number;
  won: number;
}

export interface MutationType {
  incrementGymAIPracticeGamesWon: GymAIPracticeGame;
}

// 3. Create the hook
export function useIncrementGymAIPracticeGamesWonMutation(
  options?: MutationHookOptions<MutationType, { input: IncrementGymAIPracticeGamesWonInput }>,
) {
  return useMutation<MutationType, { input: IncrementGymAIPracticeGamesWonInput }>(
    mutation,
    options,
  );
}
